module.exports = __webpack_public_path__ + "img/perfil-jgdevelop.68136ac0.jpg";